import React, { useEffect, useState, useContext } from "react";
import "./../../../../font.css";
import { kioskstyles } from "./../../../../kioskstyles";
import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";
import { Button, Grid, Typography, IconButton, TextField } from "@mui/material";

import SelectIndicator from "./LanguageButtons/SelectIndicator_V";

import SocketIOContext from "../../../../contexts/Kiosk/SocketIOProvider";

import {
  setTranslations,
  Translate,
  setLocale,
  getLocale
} from "react-i18nify";
let env = require("./../../../../env");

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function LanguageButtons(props) {
  const { getKioskTheme } = useContext(SocketIOContext);

  const [language, setLanguage] = useState("");
  const kioskverticalstyles_2 = useKioskVerticalStyles();
  const kioskTheme = getKioskTheme();

  useEffect(() => {
    setLanguage(getLocale()); //Initialize the language

    //console.log("[DEBUG] Update Language", getLocale());
  }, []);

  useEffect(() => {
    if (kioskTheme.bilingual == "false" || kioskTheme.bilingual == false) {
      setLocale("en");
      setLanguage("en");
      //setShowLanguageButtons(false);
      // console.log(
      //   "[DEBUG] LanguageButton bilingual is false, setting to ENGLISH"
      // );
    }

    if (kioskTheme.bilingual == "true" || kioskTheme.bilingual == true) {
      //setShowLanguageButtons(true);
    }
  }, [kioskTheme]);

  // console.log(
  //   "[DEBUG] LaguageButtons kioskTheme.bilingual",
  //   kioskTheme.bilingual
  // );

  if (kioskTheme.bilingual == "false" || kioskTheme.bilingual == false) {
    //console.log("[DEBUG] Hide Language Button");
    //if (showLanguageButtons == false) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between"
        }}
      ></div>
    );
  }

  const setFrench = event => {
    let locale = getLocale();

    if (props.AdditionalOnClick && locale == "fr") {
      props.AdditionalOnClick();
    } else {
      setLocale("fr");
      setLanguage("fr"); //To make sure the indicator refreshs
    }
  };

  const setEnglish = event => {
    let locale = getLocale();

    if (props.AdditionalOnClick && locale == "en") {
      props.AdditionalOnClick();
    } else {
      setLocale("en");
      setLanguage("en"); //To make sure the indicator refreshs
    }
  };

  //console.log("[DEBUG] Show Language Button");

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
      }}
    >
      <Button
        fullWidth
        variant="contained"
        onClick={setFrench}
        style={{
          //...kioskstyles.textButtons,
          ...kioskverticalstyles_2.languagebutton.languagebuttonwidget,
          marginBottom: "0px",
          marginTop: "0px"
        }}
      >
        <SelectIndicator curentLanguage={language} language={"fr"} />
        <span class="fontSecondaryText">
          <Translate value="application.languageselect.french" />
        </span>
      </Button>
      <Button
        fullWidth
        variant="contained"
        onClick={setEnglish}
        style={{
          //...kioskstyles.textButtons,
          ...kioskverticalstyles_2.languagebutton.smallerlanguagebuttonwidget,
          //...kioskverticalstyles_2.languagebutton.languagebuttonwidget,
          //margin: "0.1vh",
          marginBottom: "0px",
          marginTop: "0px"
        }}
      >
        <SelectIndicator curentLanguage={language} language={"en"} />
        <span class="fontSecondaryText">
          <Translate value="application.languageselect.english" />
        </span>
      </Button>
    </div>
  );
}

export default LanguageButtons;
